import React from 'react';
import { DiscordUserId } from './form';
export const DiscordUserIds = ({ users, onSubmit }) => {
    const discordUserIds = [];
    for (const user in users) {
        discordUserIds.push(React.createElement(DiscordUserId, { key: user, username: user, id: users[user], onSubmit: onSubmit }));
    }
    return React.createElement("div", null, discordUserIds);
};
